import { ActivityEvent } from "@/components/activity-timeline";
import {
  InteractionEvent,
  InteractionEventType,
} from "./InteractionEvent.model";

function isCommentEvent(interactionEventType: InteractionEventType): boolean {
  return (
    interactionEventType === "comment_added_by_user" ||
    interactionEventType === "comment_added_by_agent"
  );
}

function plural(count: number, who: string): string {
  return count === 1 ? `${who} Comment` : `${count} ${who} Comments`;
}

function mapSingleEvent(event: InteractionEvent): ActivityEvent {
  let eventType: string;

  switch (event.interactionEventType) {
    case "agent_changed":
      eventType = "Agent Assignment";
      break;
    case "status_changed":
      eventType = "Status Change";
      break;
    case "category_changed":
      eventType = "Category Update";
      break;
    case "topic_changed":
      eventType = "Topic Update";
      break;
    case "comment_added_by_user":
      eventType = "User Comment";
      break;
    case "comment_added_by_agent":
      eventType = "Agent Comment";
      break;
    case "autonomous":
      switch (event.quackData?.quackDecision) {
        case "skipped":
          eventType = "Ticket Skipped";
          break;
        case "escalated":
          eventType = "Ticket Escalated";
          break;
        case "answered":
          eventType = "Ticket Answered by Quack";
          break;
        case "agent_assigned":
          eventType = "Assigned to Agent";
          break;
        default:
          eventType = "Autonomous Action";
      }
      break;
    case "skill_used":
      eventType = "Skill Used";
      break;
    case "skill_failed":
      eventType = "Skill Run Failed";
      break;
    default:
      eventType = "Ticket Created";
  }

  return {
    type: eventType,
    timestamp: event.timeOfOperation,
    details: {
      previousValue: event.previousValue ?? "",
      newValue: event.newValue ?? "",
      reason: event.quackData?.reasonForDecision ?? "",
    },
  } as unknown as ActivityEvent;
}

export function convertDataToActivityEvents(
  data: InteractionEvent[]
): ActivityEvent[] {
  const output: ActivityEvent[] = [];

  for (let i = 0; i < data.length; ) {
    const current = data[i];

    if (
      current.interactionEventType === "category_changed" &&
      current.previousValue === current.newValue
    ) {
      i++;
      continue;
    }

    if (isCommentEvent(current.interactionEventType)) {
      let userCount = 0;
      let agentCount = 0;
      let j = i;

      while (j < data.length && isCommentEvent(data[j].interactionEventType)) {
        if (data[j].interactionEventType === "comment_added_by_user") {
          userCount++;
        } else {
          agentCount++;
        }
        j++;
      }

      const parts: string[] = [];
      if (agentCount) parts.push(plural(agentCount, "Agent"));
      if (userCount) parts.push(plural(userCount, "User"));

      output.push({
        type: parts.join(" and "),
        timestamp: data[j - 1].timeOfOperation,
        details: {
          previousValue: "",
          newValue: "",
          reason: "",
        },
      } as unknown as ActivityEvent);

      i = j;
    } else {
      output.push(mapSingleEvent(current));
      i++;
    }
  }

  return output;
}
